import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import api from '@/api'
import { ISparring } from '@/types/sparring'

interface IProps {
  sparring: ISparring
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudienceVoteView',
  props: {
    sparring: null
  },
  emits: ["update:sparring"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:sparring', value: ISparring): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sparring: ISparring
};




const audienceVoteColor = ref<'blue' | 'red'>()
const loading = ref(false)

async function submitAudienceScore() {
  loading.value = true

  const updatedSparring = await api.sparrings.setAudienceScore(props.sparring.sparringId, audienceVoteColor.value)
  loading.value = false
  if (!updatedSparring) return
  emit('update:sparring', updatedSparring)
}

return { __sfc: true,props, emit, audienceVoteColor, loading, submitAudienceScore }
}

})